export default __webpack_public_path__ + "static/media/7014e9d5f83d2d71.69a62ced341db9b6abd4f79066f32b7a.svg";